import RoleRewards from "@ugg/shared/components/Champions/pages/Overview/RoleRewards";
import RoleQuestRequirements from "@ugg/shared/components/Champions/pages/Overview/RoleQuestRequirements";
import { QueueTypeS } from "@ugg/shared/utils/queue-type-helpers";
import { tierListSettings } from "@ugg/shared/components/TierList/lib/tier-list-settings";
import classNames from "classnames";
interface CommonProps extends RoleQuestProps {
  className?: string;
  layout?: "row" | "column";
}
interface RoleQuestProps {
  champID: number;
  questCompletionTime?: [number];
  role: string;
  patch: string;
  queueType: QueueTypeS;
}

export default function RoleQuest(props: CommonProps) {
  const { role, champID, questCompletionTime, patch, queueType, className, layout = "row" } = props;

  if (!tierListSettings[queueType]?.showRoleQuest) {
    return null;
  }

  if (layout === "column") {
    return (
      <div className={classNames("flex flex-col gap-[1px] h-[300px]", className)}>
        <RoleQuestRequirements role={role} />
        <RoleRewards className="flex-1" champID={champID} questCompletionTime={questCompletionTime} role={role} patch={patch} />
      </div>
    );
  }

  return (
    <div className={classNames("grid grid-cols-1 gap-[12px] mt-3 md:grid-cols-2 md:gap-[1px]", className)}>
      <RoleQuestRequirements role={role} />
      <RoleRewards champID={champID} questCompletionTime={questCompletionTime} role={role} patch={patch} />
    </div>
  );
}
